/**
 * As contas da paginação da bandeja (#103): quantas páginas há e o que a contagem diz. Puro, para testar sem tela.
 */

/** Quantas páginas cabem `total` fotos, nunca menos de uma (a lista vazia ainda é uma página). */
export function totalDePaginas(total: number, porPagina: number): number {
  return Math.max(1, Math.ceil(total / porPagina));
}

/**
 * A página que vale depois que o total mudou: uma página além do fim (fotos despublicadas, um filtro mais estreito)
 * volta para a última que existe.
 */
export function paginaQueExiste(pagina: number, total: number, porPagina: number): number {
  return Math.min(pagina, totalDePaginas(total, porPagina) - 1);
}

/**
 * "Mostrando 9–16 de 37 fotos". Com uma página só, a faixa não diz nada a mais: "Mostrando 5 de 5 fotos", como a
 * contagem de sempre.
 */
export function contagemDaPagina(
  pagina: number,
  porPagina: number,
  naPagina: number,
  total: number,
): string {
  const fotos = total === 1 ? "foto" : "fotos";
  if (total <= porPagina || naPagina === 0) return `Mostrando ${naPagina} de ${total} ${fotos}`;
  const primeira = pagina * porPagina + 1;
  return `Mostrando ${primeira}–${primeira + naPagina - 1} de ${total} ${fotos}`;
}
